import { DEFAULT_TENANT } from './runtime-config'

function getCurrentHostname() {
  return typeof window !== 'undefined' ? window.location.hostname : 'localhost'
}

function isLocalHost(hostname: string) {
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname) || hostname === 'localhost'
}

function isReservedTenantSegment(segment: string) {
  return segment === 'www' || segment === 'app'
}

export function getTenantHeaderValue(
  hostname = getCurrentHostname(),
  defaultTenant = DEFAULT_TENANT,
) {

  if (isLocalHost(hostname)) {
    return defaultTenant
  }

  const parts = hostname.split('.')

  if (parts.length > 2 || (parts.length === 2 && parts[1] === 'localhost')) {
    const tenant = parts[0]

    if (!isReservedTenantSegment(tenant)) {
      return hostname
    }

    return undefined
  }

  return hostname
}

export function getBrandingHostValue(hostname = getCurrentHostname()) {

  if (isLocalHost(hostname)) {
    return undefined
  }

  const parts = hostname.split('.')

  if (parts.length > 2 || (parts.length === 2 && parts[1] === 'localhost')) {
    const tenant = parts[0]
    return isReservedTenantSegment(tenant) ? undefined : hostname
  }

  return hostname
}
